import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import styles from './BuyCreatorPlanAndUploadPlan.module.scss';
import uploadLimit from './PlanLimitUpgrades.module.scss';

import { WarningContentInfoIcon, WarningInfoIcon } from '../../assets/icons';
import {
  ADD_ONS_PRODUCT_BASE_NAME,
  RECURRING_INTERVAL,
  convertStripeCentsToAmount,
  getDateFromTimestamp,
} from './subscriptionHelper';
import useSubscriptionPurchase from '../../hooks/useSubscriptionPurchase';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsCreatorPlan,
  selectPlanList,
} from '../../redux/slicers/subscriptionSlicer';
import {
  TEXTURE_BASE_TYPE,
  THREE_3D_MODAL_BASE_TYPE,
} from '../../constants/constants';
import { openFormInCaseOfNewOrgAndFreemiumUser, SortArrayBySeq } from '../../helpers/jsHelper';
import { CheckoutUI } from '../Pricing/CheckoutUI';
import { history } from '../../history';
import { successToast, warningToast } from '../../helpers/toastHelper';
import useAddOnsInfo from '../../hooks/useAddOnsInfo';
import {
  GetAllCartProductList,
} from '../../api/subscription/subscription';
import { dispatcher } from '../../helpers/projectHelper';
import {
  UpgradeToNewPlanPatchV2,
  setClientSubscriptionPlansV2,
  setFailedClientSubscriptionPlansAndAddOnsV2,
} from '../../api/subscription/subscription';
import { CircularProgress, ModalButtonArea } from '../../common';
import { debounce } from 'lodash';
import Button from '../../components/Button';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import { userPilotEvents } from '../../common/Userpilot/userpilotHelper';
import { CycleToggle } from './CycleToggle';
import { usePermissionsHandler } from '../../hooks/usePermissions';
import { useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import { PERMISSION, PERMISSIONS } from '../../constants/permissionConstants';
let downgradeData = null;
let isPlanAddedInCart = false;
const editorMarks = { 1: 1, 20: 20, 40: 40, 60: 60, 80: 80, 100: 100 };
export default function BuyCreatorPlanAndUploadPlan({
  modifySubscription,
  wuSelectedPlanId,
  wuSelectedPlanPriceId,
  wuSelectedInterval,
  setPlanLoading,
  selfServeBillingCycle,
  setSelfServeBillingCycle,
  openCheckoutPage,
  setUpdateCheckoutAmount,
  containerStyle = {},
  isAddToPlanClickedLoading,
  setIsAddToPlanClickedLoading,
  ...props
}) {
  const {
    uploadLimitPlan,
    purchasedUploadLimitPlan,
    billingCycle: _billingCycle,
    setBillingCycle: _setBillingCycle,
    checkoutInfo,
    setCheckoutInfo,
    handlePurchasePlanV2,
    pricingDetails,
    setPricingDetails,
    originPrices,
    setOriginPrices,
    sliderValues,
    setSliderValues,
    userPlans,
    currentPlanIsCancelled,
    handleRestorePlan = () => {},
    restorePlanLoading = false
  } = useSubscriptionPurchase();
  const { handlePermissionEvent } = usePermissionsHandler();
  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();
  const dispatch = useDispatch();
  const isCreatorPlan = useSelector(selectIsCreatorPlan);
  const { isFreemiumUser } = useCurrentOrganizationInfo();
  const [open, setOpen] = useState(false);
  const { trackClickEvent } = userPilotEvents();

  const { recurringAddonsList, handleAddAddonCart, cartAddonsList } = useAddOnsInfo();
  const [textureCount, setTextureCount] = useState(0);
  const [modelCount, setModelCount] = useState(0);
  const [inputFocus, setInputFocus] = useState(false);

  const billingCycle = selfServeBillingCycle || _billingCycle;
  const setBillingCycle = (b) => {
    setSelfServeBillingCycle(b);
    _setBillingCycle(b);
  };

  const plans = useSelector(selectPlanList);
  const [currentSubscriptionData, setCurrentSubscriptionData] = useState(null);

  const [loading, setLoading] = useState(false);
  const [cancelRequestLoading, setCancelRequestLoading] = useState(false);

  const [isAddToPlanClicked, setIsAddToPlanClicked] = useState(false);
  // const activePlanPriceAmount = useSelector(selectUserActiveSubscriptionPlanPriceAmount);

  const deleteParamsValue = () => {
    if (wuSelectedPlanId || wuSelectedPlanPriceId || wuSelectedInterval) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete('selectedPlanId');
      searchParams.delete('selectedPlanPriceId');
      searchParams.delete('selectedInterval');
      searchParams.delete('isTextureType');
      history.replace({
        search: searchParams.toString(),
      });
    }
  };

  const getEditors = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const editors = searchParams.get('editors');
    return editors ? parseInt(editors) : '';
  };

  const editors = getEditors();

  useEffect(() => {
    if (!sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor]) {
      setSliderValues({
        ...sliderValues,
        [ADD_ONS_PRODUCT_BASE_NAME.Editor]: editors || 0,
      });
      setUpdateCheckoutAmount((p) => p + 1);
    }
  }, [_billingCycle, editors]);

  useEffect(() => {
    window.$isAddToPlanClicked = isAddToPlanClicked;
  }, [isAddToPlanClicked]);

  const planPricing = billingCycle === RECURRING_INTERVAL.MONTH ? 99 : 990;
  const modelLimitPlan =
    uploadLimitPlan?.length &&
    uploadLimitPlan?.find(({ basemodeltype }) => basemodeltype === THREE_3D_MODAL_BASE_TYPE);

  const textureLimitPlan =
    uploadLimitPlan?.length &&
    uploadLimitPlan?.find(({ basemodeltype }) => basemodeltype === TEXTURE_BASE_TYPE);

  const editorPlan =
    recurringAddonsList?.length &&
    recurringAddonsList?.find(
      ({ basemodeltype }) => basemodeltype === ADD_ONS_PRODUCT_BASE_NAME.Editor
    );
  const subscriptionDetails =
    userPlans &&
    userPlans?.find(({ recurring_interval }) => +recurring_interval === +_billingCycle);

  const subscriptionEndDate =
    subscriptionDetails &&
    getDateFromTimestamp(subscriptionDetails?.current_period_end_timestamp, true);

  const isActiveSubscription = !subscriptionDetails ? userPlans?.[0] : subscriptionDetails;

  // we are checking if user have any yearly subscription & that is a creator plan
  const isYearlyPlan = userPlans?.find(
    ({ recurring_interval, plan_details }) =>
      +recurring_interval == RECURRING_INTERVAL.YEAR &&
      plan_details?.some(({ is_custom_plan }) => is_custom_plan)
  );

  const getPlanEditors = (planDetails) => {
    return (
      planDetails[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.product_quantity +
      +planDetails[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.to_remove_product_quantity
    );
    // return Object.keys(editorMarks)?.find(_item => editorMarks?.[_item] === count)
  };

  useEffect(() => {
    // updating first value as initial value
    if (textureCount === 0 && modelCount === 0 && modelLimitPlan && textureLimitPlan) {
      setModelCount(
        handleCreateDynamicallyMark(modelLimitPlan, 10)[
          sliderValues?.[THREE_3D_MODAL_BASE_TYPE] || '0'
        ]
      );
      setTextureCount(
        handleCreateDynamicallyMark(textureLimitPlan, 10)[sliderValues?.Texture || '0']
      );
    }
  }, [modelLimitPlan, textureLimitPlan, sliderValues]);

  useEffect(() => {
    // Update texture & model count values when input field is not focused
    if (!inputFocus && textureCount !== 0 && modelCount !== 0) {
      setTextureCount(
        handleCreateDynamicallyMark(textureLimitPlan, 10)[sliderValues?.Texture || '0']
      );
      setModelCount(
        handleCreateDynamicallyMark(modelLimitPlan, 10)[
          sliderValues?.[THREE_3D_MODAL_BASE_TYPE] || '0'
        ]
      );
    }
  }, [sliderValues, inputFocus]);

  useEffect(() => {
    if (userPlans?.length && isYearlyPlan && isActiveSubscription) {
      const interval = isYearlyPlan
        ? RECURRING_INTERVAL.YEAR
        : isActiveSubscription?.recurring_interval;
      setCurrentSubscriptionData(interval);
      setBillingCycle(interval);
    }
  }, [userPlans?.length]);

  useEffect(() => {
    let planDetails = {};
    if (purchasedUploadLimitPlan?.length) {
      planDetails = handleSetOriginalValues();
      const texture = Object.keys(handleCreateDynamicallyMark(textureLimitPlan, 10)).find(
        (key) =>
          handleCreateDynamicallyMark(textureLimitPlan, 10)[key] ===
          uploadLimitPlan
            .find(({ basemodeltype }) => basemodeltype === TEXTURE_BASE_TYPE)
            ?.pricing_details?.find(
              ({ id, recurring_interval }) =>
                recurring_interval === billingCycle &&
                +id === +planDetails[TEXTURE_BASE_TYPE]?.price_id
            )?.quantity_details[0]?.quantity
      );
      const model = Object.keys(handleCreateDynamicallyMark(modelLimitPlan, 5)).find(
        (key) =>
          handleCreateDynamicallyMark(modelLimitPlan, 5)[key] ===
          uploadLimitPlan
            .find(({ basemodeltype }) => basemodeltype === THREE_3D_MODAL_BASE_TYPE)
            ?.pricing_details?.find(
              ({ id, recurring_interval }) =>
                recurring_interval === billingCycle &&
                +id === +planDetails[THREE_3D_MODAL_BASE_TYPE]?.price_id
            )?.quantity_details[0]?.quantity
      );
      setSliderValues({
        ...sliderValues,
        [ADD_ONS_PRODUCT_BASE_NAME.Editor]: editors || getPlanEditors(planDetails) || 1,
        [TEXTURE_BASE_TYPE]: texture || 0,
        [THREE_3D_MODAL_BASE_TYPE]: model || 0,
      });
      setUpdateCheckoutAmount((p) => p + 1);
    } else {
      setSliderValues({
        ...sliderValues,
        [ADD_ONS_PRODUCT_BASE_NAME.Editor]:
          editors || isFreemiumUser
            ? sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor] || 1
            : getPlanEditors(planDetails) || 1,
      });

      setUpdateCheckoutAmount((p) => p + 1);
    }
  }, [purchasedUploadLimitPlan, currentSubscriptionData, _billingCycle, editors]);

  useEffect(() => {
    handleSetOriginalValues();
  }, [_billingCycle]);

  const handleSetOriginalValues = () => {
    let planDetails = {};
    if (purchasedUploadLimitPlan?.length) {
      purchasedUploadLimitPlan?.map(({ plan_details, recurring_interval }) => {
        const info = plan_details?.find(
          ({ basemodeltype, is_upload_limit_plan }) =>
            basemodeltype === TEXTURE_BASE_TYPE &&
            is_upload_limit_plan &&
            +recurring_interval === +_billingCycle
        );
        if (info) {
          planDetails[TEXTURE_BASE_TYPE] = info;
        }
      });
      purchasedUploadLimitPlan?.map(({ plan_details, recurring_interval }) => {
        const info = plan_details?.find(
          ({ basemodeltype, is_upload_limit_plan }) =>
            basemodeltype === THREE_3D_MODAL_BASE_TYPE &&
            is_upload_limit_plan &&
            +recurring_interval === +_billingCycle
        );
        if (info) {
          planDetails[THREE_3D_MODAL_BASE_TYPE] = info;
        }
      });
      purchasedUploadLimitPlan?.map(({ plan_details, recurring_interval }) => {
        if (recurring_interval === +_billingCycle) {
          const info = plan_details?.find(
            ({ basemodeltype }) => basemodeltype === ADD_ONS_PRODUCT_BASE_NAME.Editor
          );
          if (info) {
            planDetails[ADD_ONS_PRODUCT_BASE_NAME.Editor] = info;
          }
        }
      });
      setOriginPrices(planDetails);
    }
    return planDetails;
  };

  const remainingCount = (type) => {
    return originPrices?.[type]?.item_counts?.total_count;
  };

  useEffect(() => {
    if (uploadLimitPlan?.length) {
      handleGetPriceId();
    }
  }, [sliderValues, billingCycle, uploadLimitPlan?.length, cartAddonsList]);

  const handleGetPriceId = () => {
    let priceDetails = {
      [THREE_3D_MODAL_BASE_TYPE]: 0,
      [TEXTURE_BASE_TYPE]: 0,
      [ADD_ONS_PRODUCT_BASE_NAME.Editor]: editors || 1,
    };
    if (sliderValues[TEXTURE_BASE_TYPE].toString()) {
      priceDetails[TEXTURE_BASE_TYPE] = uploadLimitPlan
        .find(({ basemodeltype }) => basemodeltype === TEXTURE_BASE_TYPE)
        ?.pricing_details?.find(
          ({ quantity_details, recurring_interval, is_disabled }) =>
            !is_disabled &&
            recurring_interval === billingCycle &&
            +quantity_details?.[0]?.quantity ===
              +handleCreateDynamicallyMark(textureLimitPlan, 10)[
                sliderValues?.[TEXTURE_BASE_TYPE] || 0
              ]
        );
      if (priceDetails[TEXTURE_BASE_TYPE]) {
        priceDetails[TEXTURE_BASE_TYPE] = {
          ...priceDetails[TEXTURE_BASE_TYPE],
          productType: textureLimitPlan?.producttype,
        };
      }
    }
    if (sliderValues?.[THREE_3D_MODAL_BASE_TYPE].toString()) {
      priceDetails[THREE_3D_MODAL_BASE_TYPE] = uploadLimitPlan
        .find(({ basemodeltype }) => basemodeltype === THREE_3D_MODAL_BASE_TYPE)
        ?.pricing_details?.find(
          ({ quantity_details, recurring_interval, is_disabled }) =>
            !is_disabled &&
            recurring_interval === billingCycle &&
            +quantity_details?.[0]?.quantity ===
              +handleCreateDynamicallyMark(modelLimitPlan, 5)[
                sliderValues?.[THREE_3D_MODAL_BASE_TYPE] || 0
              ]
        );
      if (priceDetails[THREE_3D_MODAL_BASE_TYPE]) {
        priceDetails[THREE_3D_MODAL_BASE_TYPE] = {
          ...priceDetails[THREE_3D_MODAL_BASE_TYPE],
          productType: modelLimitPlan?.producttype,
        };
      }
    }
    if (sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor]) {
      const editorPrice = editorPlan?.prices?.find(
        ({ recurring_interval }) => recurring_interval === billingCycle
      );
      priceDetails[ADD_ONS_PRODUCT_BASE_NAME.Editor] = editorPrice
        ? {
            ...editorPrice,
            qty: sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor] || 1,
          }
        : '';
    }
    setPricingDetails(priceDetails);
    window.$priceDetails = priceDetails;
  };

  // useEffect(() => {
  //   if (plans?.length === 0) return;

  //   // sorting the plans array based on price
  //   setSortedPlans(
  //     [...plans]
  //       .map((a) => {
  //         const pricingDetails = a?.pricing_details?.filter(
  //           (item) => item?.is_default && !item.is_archived && item?.is_self_serve_plan
  //         );
  //         if (pricingDetails?.length === 0) return null;
  //         return {
  //           ...a,
  //           pricing_details: pricingDetails,
  //         };
  //       })
  //       .filter(Boolean)
  //       .sort((a, c) => {
  //         const price1 = a?.pricing_details?.find(
  //           (item) => +item?.recurring_interval === +billingCycle
  //         )?.unit_amount;
  //         const price2 = c?.pricing_details?.find(
  //           (item) => +item?.recurring_interval === +billingCycle
  //         )?.unit_amount;

  //         return +price1 - +price2; // showing the increasing order by price
  //       })
  //   );
  // }, [plans]);

  const handleCreateDynamicallyMark = (value, minValue) => {
    let mark = {};
    let minusValue = 0;
    if (value?.pricing_details?.length) {
      SortArrayBySeq(
        [
          ...value?.pricing_details.filter(
            ({ recurring_interval, is_disabled }) =>
              !is_disabled && +recurring_interval === +billingCycle
          ),
        ],
        'unit_amount'
      )?.map((list, index) => {
        if (list?.quantity_details?.length) {
          mark[(index - minusValue) * 10] = list?.quantity_details?.[0]?.quantity;
        } else {
          minusValue = minusValue + 1;
        }
      });
      return mark;
    } else {
      return mark;
    }
  };

  const getMaxValue = (value, returnType = 'KEY') => {
    // returnType = 'KEY' or 'VALUE'
    const keys = Object.keys(value)
      ?.map(Number)
      ?.sort((a, b) => a - b);
    const secondLastKey = keys?.[keys?.length > 1 ? keys?.length - 1 : keys?.length];
    if (returnType === 'VALUE') return value?.[secondLastKey];
    return secondLastKey;
  };

  const handleBack = () => {
    setCheckoutInfo(null);
  };

  const handleCheckDowngradeRequest = async (data) => {
    const priceIdList = [];

    const addPriceIdIfConditionMet = (baseType, productTypeKey) => {
      const downgradePriceId =
        originPrices[baseType]?.next_downgrade_price_id ||
        (originPrices[baseType]?.product_quantity === 0 &&
          originPrices[baseType]?.to_remove_product_quantity > 0);
      const productTypeMatch = data?.upload_limit_prices?.find(
        ({ product_type }) => +product_type === +pricingDetails?.[baseType]?.[productTypeKey]
      );
      if (downgradePriceId && productTypeMatch) {
        priceIdList.push(originPrices[baseType]?.price_stripe_price_id);
      }
    };

    // Check upload limit prices
    if (data?.upload_limit_prices?.length) {
      addPriceIdIfConditionMet(THREE_3D_MODAL_BASE_TYPE, 'productType');
      addPriceIdIfConditionMet(TEXTURE_BASE_TYPE, 'productType');
    }
    // Check recurring prices for Editor
    const editorProduct = originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor];
    if (editorProduct?.to_remove_product_quantity > 0 && data?.recurring_prices?.length) {
      editorProduct.price_stripe_price_id && priceIdList.push(editorProduct.price_stripe_price_id);
    }
    // Handle downgrade request if priceIdList is populated
    if (priceIdList.length) {
      return await handleCancelDowngradeRequest({ priceIdList }, true);
    }

    return null;
  };

  const _handlePurchasePlan = async (data) => {
    setLoading(true);
    const res = await handleCheckDowngradeRequest(data?.payload);
    handlePurchasePlanV2({
      billingInterval: billingCycle,
      isDowngrading: false,
      skipCard: false,
      payload: data?.payload,
      callback: () => {
        setLoading(false);
        if (downgradeData) {
          handleDowngradeAPI(downgradeData, true);
        }
      },
    });
  };

  const handleChangeTextureOrModal = (e, type) => {
    if (!type) return;
    setSliderValues({
      ...sliderValues,
      [type]: e,
    });

    setUpdateCheckoutAmount((p) => p + 1);

    trackClickEvent('Creator plan', {
      plan: 'Creator',
      upgrade_type: type,
      is_yearly: billingCycle === 2,
      is_manage_subscription: false,
    });
  };

  const onInputUpdateSliderValue = ({ limits, value, callback, type }) => {
    if (!limits || !value || !type) return;

    // Find the appropriate slider mark value that's closest but not exceeding input
    const validKeys = Object.keys(limits)
      .map(Number)
      .sort((a, b) => a - b);

    const closestKey = validKeys.find((key) => limits[key] >= +value); // || validKeys[validKeys.length - 1];

    if (closestKey !== undefined) {
      callback?.(closestKey, type);
    }
  };

  const handleResetSliderValues = () => {
    setTimeout(() => {
      setUpdateCheckoutAmount((p) => p + 1);
    }, 500);
  };

  const getPlanData = () => {
    let checkoutInfo = {};
    let isTexturePlanDownload = false,
      isModalPlanDownload = false,
      isMainPlanDownload = false,
      downgradeEditor = false;
    if (originPrices?.[TEXTURE_BASE_TYPE]) {
      if (+originPrices?.[TEXTURE_BASE_TYPE]?.price_id !== +pricingDetails?.[TEXTURE_BASE_TYPE]?.id) {
        if (pricingDetails?.[TEXTURE_BASE_TYPE]) {
          checkoutInfo[TEXTURE_BASE_TYPE] = {
            ...(pricingDetails?.[TEXTURE_BASE_TYPE] || {}),
            productType: textureLimitPlan?.producttype,
          };
        }
        if (
          +originPrices?.[TEXTURE_BASE_TYPE]?.price_amount >
          +pricingDetails?.[TEXTURE_BASE_TYPE]?.unit_amount
        ) {
          isTexturePlanDownload = true;
          delete checkoutInfo[TEXTURE_BASE_TYPE];
        }
      }
    } else {
      if (pricingDetails?.[TEXTURE_BASE_TYPE]) {
        checkoutInfo[TEXTURE_BASE_TYPE] = {
          ...(pricingDetails?.[TEXTURE_BASE_TYPE] || {}),
          productType: textureLimitPlan?.producttype,
        };
        isTexturePlanDownload = false;
      }
    }
    if (originPrices?.[THREE_3D_MODAL_BASE_TYPE]) {
      if (
        +originPrices?.[THREE_3D_MODAL_BASE_TYPE]?.price_id !==
        +pricingDetails?.[THREE_3D_MODAL_BASE_TYPE]?.id
      ) {
        if (pricingDetails?.[THREE_3D_MODAL_BASE_TYPE]) {
          checkoutInfo[THREE_3D_MODAL_BASE_TYPE] = {
            ...pricingDetails?.[THREE_3D_MODAL_BASE_TYPE],
            productType: modelLimitPlan?.producttype,
          };
        }
        if (
          +originPrices?.[THREE_3D_MODAL_BASE_TYPE]?.price_amount >
          +pricingDetails?.[THREE_3D_MODAL_BASE_TYPE]?.unit_amount
        ) {
          isModalPlanDownload = true;
          delete checkoutInfo[THREE_3D_MODAL_BASE_TYPE];
        }
      }
    } else {
      if (pricingDetails?.[THREE_3D_MODAL_BASE_TYPE]) {
        checkoutInfo[THREE_3D_MODAL_BASE_TYPE] = {
          ...pricingDetails?.[THREE_3D_MODAL_BASE_TYPE],
          productType: modelLimitPlan?.producttype,
        };
        isModalPlanDownload = false;
      }
    }

    if (originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]) {
      if (
        +originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.price_id ===
        +pricingDetails?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.id
      ) {
        if (
          +(
            originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.product_quantity +
            +originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.to_remove_product_quantity
          ) !== +sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor]
        ) {
          /// upgrade the editor
          if (
            +(
              originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.product_quantity +
              +originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.to_remove_product_quantity
            ) < +sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor]
          ) {
            downgradeEditor = false;
            checkoutInfo[ADD_ONS_PRODUCT_BASE_NAME.Editor] = {
              ...(pricingDetails?.[ADD_ONS_PRODUCT_BASE_NAME.Editor] || {}),
              qty:
                +sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor] -
                +(
                  +originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.product_quantity +
                  +originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.to_remove_product_quantity
                ),
              actualQty: +sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor],
            };
          } else {
            downgradeEditor = true;
            // downgrade the editor
          }
        }
      } else {
        // for new editor purchase
        if (pricingDetails?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]) {
          checkoutInfo[ADD_ONS_PRODUCT_BASE_NAME.Editor] = {
            ...(pricingDetails?.[ADD_ONS_PRODUCT_BASE_NAME.Editor] || {}),
            qty:
              sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor] -
              +(
                +originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.product_quantity +
                +originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.to_remove_product_quantity
              ),
          };
        }
      }
    } else {
      if (pricingDetails?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]) {
        checkoutInfo[ADD_ONS_PRODUCT_BASE_NAME.Editor] = {
          ...(pricingDetails?.[ADD_ONS_PRODUCT_BASE_NAME.Editor] || {}),
          qty: sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor],
        };
      }
    }

    return {
      checkoutInfo,
      isTexturePlanDownload,
      isModalPlanDownload,
      isMainPlanDownload,
      downgradeEditor,
    };
  };

  const handleCheckout = ({
    checkoutInfo,
    isTexturePlanDownload,
    isModalPlanDownload,
    isMainPlanDownload,
    downgradeEditor,
  }) => {
    if (isTexturePlanDownload || isModalPlanDownload || isMainPlanDownload || downgradeEditor) {
      if (!Object.keys(checkoutInfo)?.length) {
        setOpen({ isTexturePlanDownload, isModalPlanDownload, downgradeEditor });
        return;
      }
      downgradeData = { isTexturePlanDownload, isModalPlanDownload, downgradeEditor };
      setCheckoutInfo(checkoutInfo);
    } else {
      if (!Object.keys(checkoutInfo)?.length) {
        warningToast('Please modify or upgrade the item limit to proceed to checkout.');
        return;
      }
      setCheckoutInfo(checkoutInfo);
    }
  };

  const handleDowngradeAPI = async (data, hideSuccessMessage = false) => {
    let payload = { add_subscription_items: false, data: [] };
    if (subscriptionDetails) {
      if (data?.isTexturePlanDownload) {
        const currentSelectedPriceInfo = pricingDetails?.[TEXTURE_BASE_TYPE];
        const originalPriceInfo = originPrices?.[TEXTURE_BASE_TYPE];
        payload.data.push({
          remove_item_id: originalPriceInfo?.price_stripe_price_id,
          downgraded_item_id: currentSelectedPriceInfo?.stripe_price_id,
          remove_item_quantity: 1,
        });
      }
      if (data?.isModalPlanDownload) {
        const currentSelectedPriceInfo = pricingDetails?.[THREE_3D_MODAL_BASE_TYPE];
        const originalPriceInfo = originPrices?.[THREE_3D_MODAL_BASE_TYPE];
        payload.data.push({
          remove_item_id: originalPriceInfo?.price_stripe_price_id,
          downgraded_item_id: currentSelectedPriceInfo?.stripe_price_id,
          remove_item_quantity: 1,
        });
      }
      if (data?.downgradeEditor) {
        const currentQty = sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor];
        const oldQty = +(
          originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.product_quantity +
          +originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.to_remove_product_quantity
        );
        const currentPrice = originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor];
        payload.data.push({
          remove_item_id: currentPrice?.price_stripe_price_id,
          remove_item_quantity: oldQty - currentQty,
        });
        if (+originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.to_remove_product_quantity > 0) {
          await handleCancelDowngradeRequest(originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor], true);
        }
      }
      setLoading('downgrade');
      const res = await UpgradeToNewPlanPatchV2(payload, subscriptionDetails?.id);
      if (res) {
        downgradeData = null;
        if (!hideSuccessMessage) {
          successToast('Downgrade request successfully added.');
        }
        dispatch(setClientSubscriptionPlansV2());
        dispatch(setFailedClientSubscriptionPlansAndAddOnsV2());
        setOpen(false);
      }
      setLoading(false);
    }
  };

  const handleDowngradeBeforeModal = (data) => {
    let payload = [];
    if (data?.isModalPlanDownload) {
      const currentSelectedPriceInfo = pricingDetails?.[THREE_3D_MODAL_BASE_TYPE];
      payload.push({
        descriptions: (
          <p>
            <b>Models :</b> Limited to the latest{' '}
            <b>{currentSelectedPriceInfo?.quantity_details?.[0]?.quantity} Models</b>
          </p>
        ),
      });
    }
    if (data?.isTexturePlanDownload) {
      const currentSelectedPriceInfo = pricingDetails?.[TEXTURE_BASE_TYPE];
      payload.push({
        descriptions: (
          <p>
            <b>Textures :</b> Limited to the latest{' '}
            <b>{currentSelectedPriceInfo?.quantity_details?.[0]?.quantity} Textures</b>
          </p>
        ),
      });
    }
    if (data?.downgradeEditor) {
      const currentQty = sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor];
      payload.push({
        descriptions: (
          <p>
            <b>Editors :</b> Limited to the latest{' '}
            <b>
              {currentQty} Editor{currentQty > 1 ? 's' : ''}.
            </b>
          </p>
        ),
      });
    }
    return (
      <div className={uploadLimit.downgradePlanModal}>
        <p>
          <WarningContentInfoIcon />
        </p>
        <h3>Confirm Downgrade Request</h3>
        <>
          <p>
            Starting from your next billing cycle i.e., <b>{subscriptionEndDate}</b>, after your
            current subscription ends, your access will be adjusted as follows:
          </p>
          {payload?.length > 0 &&
            payload.map((list) => {
              return list.descriptions;
            })}
          <p>Please confirm to proceed with the downgrade request.</p>
        </>
        <div className="d-flex align-items-end gap-3 mt-4">
          <Button
            size="sm"
            className="flex-fill"
            style={{
              color: '#fff',
              height: '32px',
            }}
            loading={loading === 'downgrade'}
            onClick={() => {
              handleDowngradeAPI(data);
            }}>
            Confirm
          </Button>
          <Button
            style={{
              color: '#56544F',
              background: '#EFEDE8',
              height: '32px',
            }}
            size="sm"
            className="flex-fill"
            onClick={() => setOpen(false)}>
            <span style={{ color: '#56544F' }}>Cancel</span>
          </Button>
        </div>
      </div>
    );
  };

  const handleGetTotalAmount = () => {
    let totalPrice = 0;
    pricingDetails &&
      Object.keys(pricingDetails)?.map((list) => {
        totalPrice =
          +totalPrice +
          (pricingDetails?.[list]?.qty || 1) *
            +(
              pricingDetails?.[list]?.unit_amount ||
              pricingDetails?.[list]?.pricing_details?.unit_amount ||
              0
            );
      });
    return convertStripeCentsToAmount(totalPrice);
  };

  const handleAddPlan = async ({ openCheckout = false } = {}) => {
    if (!pricingDetails || isAddToPlanClickedLoading) return;
    trackClickEvent('Add to plan', {
      plan: 'Creator',
      cost: handleGetTotalAmount(),
      upgrade_type: 'Model/Texture/Editor',
      is_yearly: billingCycle === 2,
    });

    const _isPlanAddedInCart = !isAddToPlanClicked;
    setIsAddToPlanClicked(_isPlanAddedInCart);
    setIsAddToPlanClickedLoading(true);
    await Promise.all(
      Object.keys(pricingDetails).map(async (key) => {
        let data = { ...pricingDetails[key] };
        data = { ...data, id: data?.product, objectId: data?.id, quantity: 0 };
        // await handleAddAddonCart(data, false); // removing item from the cart
        // await handleAddAddonCart(data, true); // adding item to the cart

        if (_isPlanAddedInCart) {
          await handleAddAddonCart(data, true); // adding item to the cart
        } else {
          await handleAddAddonCart(data, false); // removing item from the cart
        }
      })
    );
    setTimeout(() => setIsAddToPlanClickedLoading(false), 1000);
    dispatcher(GetAllCartProductList());
    if (openCheckout) {
      deleteParamsValue();
      openCheckoutPage();
    }

    if (_isPlanAddedInCart) {
      const textures =
        handleCreateDynamicallyMark(textureLimitPlan, 10)?.[0] !==
        pricingDetails?.[TEXTURE_BASE_TYPE]?.quantity_details?.[0]?.quantity;
      const models =
        handleCreateDynamicallyMark(modelLimitPlan, 5)?.[0] !==
        pricingDetails?.[THREE_3D_MODAL_BASE_TYPE]?.quantity_details?.[0]?.quantity;
      const editor = pricingDetails?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.qty !== 1;
      trackClickEvent('Add to plan', {
        plan: 'Creator',
        cost: handleGetTotalAmount(),
        upgrade_type: `${models ? 'Model,' : ''}${textures ? 'Texture,' : ''}${
          editor ? 'Editor' : ''
        }`,
        is_yearly: billingCycle === 2,
      });
    }
  };

  const showClickedButtonIfAdded = debounce(() => {
    const cartList = cartAddonsList?.map((a) => a?.subscription_price);
    Object.keys(pricingDetails).map(async (key) => {
      if (cartList?.includes(pricingDetails?.[key]?.product)) {
        setIsAddToPlanClicked(true);
      } else {
        setIsAddToPlanClicked(false);
      }
    });
  }, 300);

  useEffect(() => {
    if (!isAddToPlanClickedLoading) {
      if (cartAddonsList?.length > 0 && pricingDetails) {
        showClickedButtonIfAdded();
      } else {
        setIsAddToPlanClicked(false);
      }
    }
  }, [cartAddonsList, pricingDetails]);

  useEffect(() => {
    if (wuSelectedInterval && pricingDetails && !isPlanAddedInCart) {
      setBillingCycle(+wuSelectedInterval);

      handleAddPlan({
        openCheckout: true,
      });
      isPlanAddedInCart = true;
    }
    return () => {
      isPlanAddedInCart = false;
    };
  }, [wuSelectedInterval, plans, pricingDetails]);

  const handleCancelDowngradeRequest = async (data, hideSuccessMessage) => {
    !hideSuccessMessage && setCancelRequestLoading(data?.basemodeltype);
    if (subscriptionDetails?.id) {
      const payload = {
        cancel_downgrade: true,
        data: data?.priceIdList ? data?.priceIdList : [data?.price_stripe_price_id],
      };
      const res = await UpgradeToNewPlanPatchV2(payload, subscriptionDetails?.id);
      setCancelRequestLoading(false);
      if (res) {
        if (!hideSuccessMessage) {
          successToast('Request canceled successfully.');
          dispatch(setClientSubscriptionPlansV2());
          dispatch(setFailedClientSubscriptionPlansAndAddOnsV2());
        }
      }
      return res;
    }
  };

  const handleGetPrice = (priceId) => {
    if (priceId) {
      let priceDetails = null;
      uploadLimitPlan.find((list) => {
        if (list?.pricing_details?.find(({ stripe_price_id }) => stripe_price_id === priceId)) {
          priceDetails = list?.pricing_details?.find(
            ({ stripe_price_id }) => stripe_price_id === priceId
          );
        }
      });
      if (priceDetails) {
        return priceDetails?.quantity_details?.[0]?.quantity || 0;
      }
      return 0;
    }
    return 0;
  };

  const handleGetFeature = () => {
    let data = [
      {
        id: 1,
        description: `4K high resolution renders`,
      },
      {
        id: 2,
        description: `Fast previews without watermark`,
      },
      {
        id: 3,
        description: `Unlimited Rendering`,
      },
      {
        id: 4,
        description: `${
          handleCreateDynamicallyMark(modelLimitPlan, 5)[
            sliderValues[THREE_3D_MODAL_BASE_TYPE] || '0'
          ]
        } Models, ${
          handleCreateDynamicallyMark(textureLimitPlan, 10)[sliderValues[TEXTURE_BASE_TYPE] || '0']
        } Textures`,
      },
    ];

    if (sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.toString()) {
      data.push({
        id: data?.length + 1,
        description: `${sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor] || 0} Editors`,
      });
    }

    return data;
  };

  const planFeatures = handleGetFeature();
  let {
    checkoutInfo: _checkoutInfo,
    isTexturePlanDownload,
    isModalPlanDownload,
    isMainPlanDownload,
    downgradeEditor,
  } = getPlanData();

  const handleRestoreCancelCurrentPlan = () => {
    handlePermissionEvent(
      PERMISSION.SUBSCRIPTION,
      (r) => {
        if (r === undefined) {
          handleRestorePlan()
          // openInfoDialog({
          //   title: 'Restoring plan!',
          //   description: 'Your plan will continue from now.',
          //   cancelButtonText: "Don't restore",
          //   buttonText: 'Restore Creator Plan',
          //   onButtonClick: handleRestorePlan,
          //   open: true,
          // });
        }
      },
      PERMISSIONS.SUBSCRIPTION.warningMessage
    )();
  };

  return (
    <div className={`${styles.container} ${!modifySubscription && 'mt-0'}`} style={containerStyle}>
      <div className={styles.topSection}>
        <div>
          {isCreatorPlan ? (
            <>
              <h2 className={styles.title}>Creator Plan</h2>
              {currentPlanIsCancelled?.() ? (
                <p>{`Your Creator Plan is scheduled to be canceled on ${getDateFromTimestamp(
                  isActiveSubscription?.current_period_end_timestamp,
                  false
                )}.`}</p>
              ) : (
                <p>{`This plan will be renewed on ${getDateFromTimestamp(
                  isActiveSubscription?.current_period_end_timestamp,
                  false
                )}.`}</p>
              )}
            </>
          ) : (
            <>
              <h2 className={styles.title}>
                The Creator Plan is specifically crafted to meet your needs, Starting at{' '}
                <span className={styles.price}>
                  ${planPricing}
                </span>
                .
              </h2>
              <p>Customise your experience</p>
            </>
          )}
        </div>
        {!isCreatorPlan ? (
          <CycleToggle
            cycle={billingCycle}
            setCycle={(c) => {
              handleResetSliderValues();
              setBillingCycle(c);
            }}
          />
         ) : null}
      </div>
      <div className={styles.centerSection}>
        <div className={styles.features}>
          <span className={styles.includedText}>What’s included?</span>
          <ul>
            {planFeatures?.length > 0 &&
              planFeatures?.map((feature) => {
                return <li key={feature?.id}>{feature?.description}</li>;
              })}
          </ul>
        </div>

        <div className={styles.sliderContainer}>
          <div className={styles.sliders}>
            <p className={styles.sliderLabel}>
              Customize your plan by changing the limits of the items.
            </p>
            {modelLimitPlan && getMaxValue(handleCreateDynamicallyMark(modelLimitPlan, 5)) !== 0 ? (
              <div className={styles.sliderItem}>
                <span className={styles.labelName}>Models</span>
                <Slider
                  value={sliderValues[THREE_3D_MODAL_BASE_TYPE] || '0'}
                  min={0}
                  step={10}
                  onChange={(e) => handleChangeTextureOrModal(e, THREE_3D_MODAL_BASE_TYPE)}
                  max={getMaxValue(handleCreateDynamicallyMark(modelLimitPlan, 5))}
                  marks={handleCreateDynamicallyMark(modelLimitPlan, 5)}
                />
                <input
                  min={1}
                  className={styles.sliderInput}
                  type="number"
                  // value={
                  //   handleCreateDynamicallyMark(modelLimitPlan, 5)[
                  //     sliderValues[THREE_3D_MODAL_BASE_TYPE] || '0'
                  //   ]
                  // }
                  value={modelCount}
                  onChange={(e) => {
                    setModelCount(e.target.value);

                    const value = e.target.value;
                    const limits = handleCreateDynamicallyMark(modelLimitPlan, 10);

                    onInputUpdateSliderValue({
                      value,
                      limits,
                      callback: handleChangeTextureOrModal,
                      type: THREE_3D_MODAL_BASE_TYPE,
                    });

                    // opening a form if the user enters above the limit
                    if (
                      e.target.value >
                      getMaxValue(handleCreateDynamicallyMark(modelLimitPlan, 5), 'VALUE')
                    ) {
                      openFormInCaseOfNewOrgAndFreemiumUser();
                    }
                  }}
                  onFocus={() => setInputFocus(true)}
                  onBlur={() => {
                    setInputFocus(false);
                    setModelCount(
                      handleCreateDynamicallyMark(modelLimitPlan, 10)[
                        sliderValues?.[THREE_3D_MODAL_BASE_TYPE] || '0'
                      ]
                    );
                  }}
                />
              </div>
            ) : null}
            {textureLimitPlan &&
            getMaxValue(handleCreateDynamicallyMark(textureLimitPlan, 10)) !== 0 ? (
              <div className={styles.sliderItem}>
                <span className={styles.labelName}>Textures</span>
                <Slider
                  value={sliderValues[TEXTURE_BASE_TYPE] || '0'}
                  min={0}
                  step={10}
                  onChange={(e) => handleChangeTextureOrModal(e, TEXTURE_BASE_TYPE)}
                  max={getMaxValue(handleCreateDynamicallyMark(textureLimitPlan, 10))}
                  marks={handleCreateDynamicallyMark(textureLimitPlan, 10)}
                />
                <input
                  min={1}
                  className={styles.sliderInput}
                  type="number"
                  // value={
                  //   handleCreateDynamicallyMark(textureLimitPlan, 10)[sliderValues?.Texture || '0']
                  // }
                  value={textureCount}
                  onChange={(e) => {
                    setTextureCount(e.target.value);

                    const value = e.target.value;
                    const limits = handleCreateDynamicallyMark(textureLimitPlan, 10);

                    onInputUpdateSliderValue({
                      value,
                      limits,
                      callback: handleChangeTextureOrModal,
                      type: TEXTURE_BASE_TYPE,
                    });

                    // opening a form if the user enters above the limit
                    if (
                      e.target.value >
                      getMaxValue(handleCreateDynamicallyMark(textureLimitPlan, 10), 'VALUE')
                    ) {
                      openFormInCaseOfNewOrgAndFreemiumUser();
                    }
                  }}
                  onFocus={() => setInputFocus(true)}
                  onBlur={() => {
                    setInputFocus(false);
                    setTextureCount(
                      handleCreateDynamicallyMark(textureLimitPlan, 10)[
                        sliderValues?.Texture || '0'
                      ]
                    );
                  }}
                />
              </div>
            ) : null}
            <div className={styles.sliderItem}>
              <span className={styles.labelName}>Editors</span>
              <Slider
                step={1}
                min={1}
                max={100}
                value={sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor]}
                marks={editorMarks}
                onChange={(e) => {
                  handleChangeTextureOrModal(e, ADD_ONS_PRODUCT_BASE_NAME.Editor);
                }}
              />
              <input
                min={1}
                className={styles.sliderInput}
                type="number"
                value={sliderValues[ADD_ONS_PRODUCT_BASE_NAME.Editor]}
                onChange={(e) => {
                  setSliderValues({
                    ...sliderValues,
                    [ADD_ONS_PRODUCT_BASE_NAME.Editor]:
                      e.target.value > 100 ? 100 : e.target.value < 1 ? 1 : e.target.value,
                  });

                  setUpdateCheckoutAmount((p) => p + 1);

                  // opening a form if the user enters above the limit
                  if (e.target.value > 100) {
                    openFormInCaseOfNewOrgAndFreemiumUser();
                  }
                }}
              />
            </div>
          </div>
          <div className={styles.totalAmount}>
            <span className={styles.totalAmountLabel}>Total Amount</span>
            <h2 className="d-flex">
              {+handleGetTotalAmount() === 0 ? (
                <CircularProgress className="circleLoaderPosition" size={14} thickness={1} />
              ) : (
                `$${handleGetTotalAmount()}`
              )}
              <span>/{billingCycle === RECURRING_INTERVAL.MONTH ? 'Month' : 'Year'}</span>
            </h2>
            <button
              style={
                !(
                  isTexturePlanDownload ||
                  isModalPlanDownload ||
                  isMainPlanDownload ||
                  downgradeEditor
                ) &&
                !Object.keys(_checkoutInfo)?.length &&
                !currentPlanIsCancelled?.()
                  ? { visibility: 'hidden' }
                  : {}
              }
              onClick={
                currentPlanIsCancelled?.()
                  ? () => handleRestoreCancelCurrentPlan()
                  : isCreatorPlan
                  ? () =>
                      handleCheckout({
                        checkoutInfo: _checkoutInfo,
                        isTexturePlanDownload,
                        isModalPlanDownload,
                        isMainPlanDownload,
                        downgradeEditor,
                      })
                  : () => handleAddPlan()
              }
              className={cx(
                styles.upgradeButton,
                !isCreatorPlan && isAddToPlanClicked ? styles.isAddToPlanClicked : ''
              )}>
              {(isAddToPlanClickedLoading || restorePlanLoading) ? (
                <CircularProgress
                  className={!isAddToPlanClicked ? 'loaderColorWhite' : 'loaderColorBlack'}
                  size={26}
                  thickness={3}
                />
              ) : currentPlanIsCancelled?.() ? (
                'Restore plan'
              ) : isCreatorPlan ? (
                'Update plan'
              ) : !isAddToPlanClicked ? (
                'Add to plan'
              ) : (
                'Remove'
              )}
            </button>
          </div>
        </div>
      </div>

      {(!currentPlanIsCancelled() && (originPrices?.[THREE_3D_MODAL_BASE_TYPE]?.next_downgrade_price_id ||
        (+originPrices?.[THREE_3D_MODAL_BASE_TYPE]?.product_quantity === 0 &&
          +originPrices?.[THREE_3D_MODAL_BASE_TYPE]?.to_remove_product_quantity > 0))) && (
        <div className={styles.bannerSection}>
          <p>
            <span className="me-1">
              <WarningInfoIcon />
            </span>
            {+originPrices?.[THREE_3D_MODAL_BASE_TYPE]?.product_quantity === 0 &&
            +originPrices?.[THREE_3D_MODAL_BASE_TYPE]?.to_remove_product_quantity > 0
              ? `Your Creator Plan model Limit are set to be cancelled, You will have access to ${remainingCount(
                  THREE_3D_MODAL_BASE_TYPE
                )} models until ${subscriptionEndDate}.`
              : `Your Creator Plan model limit are set to be downgraded to ${handleGetPrice(
                  originPrices?.[THREE_3D_MODAL_BASE_TYPE]?.next_downgrade_price_id
                )}, You will have access to ${remainingCount(THREE_3D_MODAL_BASE_TYPE)} models until
              ${subscriptionEndDate}.`}
          </p>
          <span
            onClick={() => handleCancelDowngradeRequest(originPrices?.[THREE_3D_MODAL_BASE_TYPE])}>
            {cancelRequestLoading === THREE_3D_MODAL_BASE_TYPE ? (
              <CircularProgress size={18} thickness={2} />
            ) : (
              'Cancel Request'
            )}
          </span>
        </div>
      )}
      {(!currentPlanIsCancelled() && (originPrices?.[TEXTURE_BASE_TYPE]?.next_downgrade_price_id ||
        (+originPrices?.[TEXTURE_BASE_TYPE]?.product_quantity === 0 &&
          +originPrices?.[TEXTURE_BASE_TYPE]?.to_remove_product_quantity > 0))) && (
        <div className={styles.bannerSection}>
          <p>
            <span className="me-1">
              <WarningInfoIcon />
            </span>

            {+originPrices?.[TEXTURE_BASE_TYPE]?.product_quantity === 0 &&
            +originPrices?.[TEXTURE_BASE_TYPE]?.to_remove_product_quantity > 0
              ? `Your Creator Plan texture Limit are set to be cancelled, You will have access to ${remainingCount(
                  TEXTURE_BASE_TYPE
                )} textures until ${subscriptionEndDate}.`
              : `Your Creator Plan texture limit are set to be downgraded to ${handleGetPrice(
                  originPrices?.[TEXTURE_BASE_TYPE]?.next_downgrade_price_id
                )}, You will have access to ${remainingCount(TEXTURE_BASE_TYPE)} textures until
              ${subscriptionEndDate}.`}
          </p>
          <span onClick={() => handleCancelDowngradeRequest(originPrices?.[TEXTURE_BASE_TYPE])}>
            {cancelRequestLoading === TEXTURE_BASE_TYPE ? (
              <CircularProgress size={18} thickness={2} />
            ) : (
              'Cancel Request'
            )}
          </span>
        </div>
      )}

      {!currentPlanIsCancelled() && +originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.to_remove_product_quantity > 0 && (
        <div className={styles.bannerSection}>
          <p>
            <span className="me-1">
              <WarningInfoIcon />
            </span>
            {+originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.product_quantity === 0 &&
            +originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.to_remove_product_quantity > 0
              ? `Your Creator Plan Editor seats are set to be cancelled, You will have access to ${remainingCount(
                  ADD_ONS_PRODUCT_BASE_NAME.Editor
                )} editors until ${subscriptionEndDate}.`
              : `Your Creator Plan editor seats are set to be downgraded to ${
                  originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor]?.product_quantity
                }, You will have access to ${remainingCount(
                  ADD_ONS_PRODUCT_BASE_NAME.Editor
                )} editors until ${subscriptionEndDate}.`}
          </p>
          <span
            onClick={() =>
              handleCancelDowngradeRequest(originPrices?.[ADD_ONS_PRODUCT_BASE_NAME.Editor])
            }>
            {cancelRequestLoading === ADD_ONS_PRODUCT_BASE_NAME.Editor ? (
              <CircularProgress size={18} thickness={2} />
            ) : (
              'Cancel Request'
            )}
          </span>
        </div>
      )}

      <ModalButtonArea
        size={'md'}
        startOpen={Boolean(open)}
        showModal={Boolean(open)}
        setShowModal={() => setOpen(false)}
        centered={true}
        className={`${styles.registerFlowContainer} ${props?.dialogClassName} ${
          props?.applyBg ? styles.applyBgColor : ''
        }`}
        bigButton={false}
        bigIcon={true}
        variant="link"
        hideCloseButton={true}
        backdropClassName="overlay-dark"
        headingLeft
        body={<>{handleDowngradeBeforeModal(open)}</>}
      />

      {/* checkout */}
      {checkoutInfo ? (
        <CheckoutUI
          checkoutInfo={checkoutInfo}
          billingCycle={billingCycle}
          setBillingCycle={setBillingCycle}
          goBack={handleBack}
          handlePurchase={_handlePurchasePlan}
          loading={loading}
          subscriptionDetails={subscriptionDetails}
          isCurrentPlanIsCancelled={currentPlanIsCancelled()}
        />
      ) : null}
    </div>
  );
}
